<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Revolve</h1>
          <figure class="image">
            <img src="static/images/revolve/revolve_01-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px">
          <p class="title">
            Revolve is a modular space divider crafted from locally sourced
            Finnish red clay.
          </p>
          <p>
            The three-dimensional elements are designed to rotate around their
            axis, allowing users to interact with the piece while creating a
            dynamic play of light and shadow in the space. Made in extruded
            terracotta, the rough and earthy surface of red clay brings warmth
            and character to any interior.
            <br />
            <br />
            Revolve elements are available in matte or glossy finishes. Produced
            artisanally in Helsinki, Revolve space dividers can be customized to
            fit both residential and public spaces. The design and the pieces
            are created in collaboration with my colleague Ville Auvinen (<a
              href="https://www.studiovilleauvinen.com"
              target="_blank"
              >www.studiovilleauvinen.com</a
            >).
          </p>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/revolve/revolve_02-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/revolve/revolve_04-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/revolve/revolve_03-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/revolve/revolve_05-highres.jpg" />
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mediumZoom from "medium-zoom";

export default {
  mounted() {
    mediumZoom(".zoom-default");
  },
};
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Revolve.vue